import React, { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./Sidebar.css";
import { useSelector } from "react-redux";

const menuItems = [
  {
    title: "By category",
    url: "/",
    submenu: [
      { title: "All", url: "/" },
      {
        title: "Rings",
        url: "/",
        submenu: [
          { title: "All rings", url: "/home/rings" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/rings/u1500" },
          { title: "1500-3000", url: "/home/rings/15h30h" },
          { title: "3000-5000", url: "/home/rings/30h50h" },
          { title: "above 5000", url: "/home/rings/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/rings/silver" },
          { title: "Pure Gold", url: "/home/rings/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/rings/silver" },
          { title: "Gold Plated", url: "/home/rings/goldplated" },
          { title: "Rose Gold", url: "/home/rings/rosegold" },
          { title: "Oxidised", url: "/home/rings/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/rings/everyday" },
          { title: "office", url: "/home/rings/office" },
          { title: "Party", url: "/home/rings/party" },
        ],
      },
      {
        title: "Necklaces & Pendants",
        url: "/",
        submenu: [
          {
            title: "All Necklaces & Pendants",
            url: "/",
          },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/necklaces&Pendants/u1500" },
          { title: "1500-3000", url: "/home/necklaces&Pendants/15h30h" },
          { title: "3000-5000", url: "/home/necklaces&Pendantss/30h50h" },
          { title: "above 5000", url: "/home/necklaces&Pendants/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/necklaces&Pendants/silver" },
          { title: "Pure Gold", url: "/home/necklaces&Pendants/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/necklaces&Pendants/silver" },
          { title: "Gold Plated", url: "/home/necklaces&Pendants/goldplated" },
          { title: "Rose Gold", url: "/home/necklaces&Pendants/rosegold" },
          { title: "Oxidised", url: "/home/necklaces&Pendants/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/necklaces&Pendants/everyday" },
          { title: "office", url: "/home/necklaces&Pendants/office" },
          { title: "Party", url: "/home/necklaces&Pendants/party" },
        ],
      },
      {
        title: "Bracelets",
        url: "/",
        submenu: [
          { title: "All Bracelets", url: "/" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/bracelets/u1500" },
          { title: "1500-3000", url: "/home/bracelets/15h30h" },
          { title: "3000-5000", url: "/home/bracelets/30h50h" },
          { title: "above 5000", url: "/home/bracelets/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/bracelets/silver" },
          { title: "Pure Gold", url: "/home/bracelets/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/bracelets/silver" },
          { title: "Gold Plated", url: "/home/bracelets/goldplated" },
          { title: "Rose Gold", url: "/home/bracelets/rosegold" },
          { title: "Oxidised", url: "/home/bracelets/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/bracelets/everyday" },
          { title: "office", url: "/home/bracelets/office" },
          { title: "Party", url: "/home/bracelets/party" },
        ],
      },
      {
        title: "Earrings",
        url: "/",
        submenu: [
          { title: "All Earrings", url: "/home/earrings" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/earrings/u1500" },
          { title: "1500-3000", url: "/home/earrings/15h30h" },
          { title: "3000-5000", url: "/home/earrings/30h50h" },
          { title: "above 5000", url: "/home/earrings/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/earrings/silver" },
          { title: "Pure Gold", url: "/home/earrings/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/earrings/silver" },
          { title: "Gold Plated", url: "/home/earrings/goldplated" },
          { title: "Rose Gold", url: "/home/earrings/rosegold" },
          { title: "Oxidised", url: "/home/earrings/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/earrings/everyday" },
          { title: "office", url: "/home/earrings/office" },
          { title: "Party", url: "/home/earrings/party" },
        ],
      },
    ],
  },
  {
    title: "About",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/about/submenu1" },
      { title: "Submenu 2", url: "/about/submenu2" },
    ],
  },
  {
    title: "Services",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/services/submenu1" },
      { title: "Submenu 2", url: "/services/submenu2" },
    ],
  },
  {
    title: "Contact",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/contact/submenu1" },
      { title: "Submenu 2", url: "/contact/submenu2" },
    ],
  },
];

function MenuItem({ item }) {
  const [open, setOpen] = useState(false);

  const [parentWidth, setParentWidth] = useState(15);
  const ref = useRef(null);

  const toggleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (ref.current) {
      const parentElement = ref.current.parentElement;
      const parentComputedStyle = window.getComputedStyle(parentElement);
      const parentWidth = parentElement.clientWidth;
      const parentMarginRight = parseFloat(parentComputedStyle.marginRight);
      const margin = parentWidth * 0.05 + parentMarginRight;
      setParentWidth(margin);
    }
  }, [open]);

  return (
    <>
      <div ref={ref}>
        {item.submenu ? (
          <>
            <div
              className="sidemenuItem"
              style={{ marginRight: `${parentWidth}vh` }}
            >
              {open ? (
                <ExpandLessIcon
                  onClick={toggleOpen}
                  sx={{ fontSize: "larger", color: "#cb835b" }}
                />
              ) : (
                <ExpandMoreIcon
                  onClick={toggleOpen}
                  sx={{ fontSize: "larger", color: "#cb835b" }}
                />
              )}
              <div className="sidebarMenu">
                <span>
                  {item.url === "/" ? (
                    <span className="sidebarMenuTitle">{item.title}</span>
                  ) : (
                    <span>{item.title}</span>
                  )}
                </span>
              </div>
            </div>
            {open &&
              item.submenu.map((subItem, index) => (
                <MenuItem key={index} item={subItem} />
              ))}
          </>
        ) : (
          <div className="sidebarMenu">
            <span>
              {item.url === "/" ? (
                <span className="sidebarMenuTitle">{item.title}</span>
              ) : (
                <a href={item.url}>{item.title}</a>
              )}
            </span>
          </div>
        )}
      </div>
    </>
  );
}

const Sidebar = () => {
  const isOpen = useSelector((state) => state.sidebar);
 if(isOpen){
    document.body.classList.toggle('no-scroll', isOpen);
  };
  return (
    <div className="sidemenu" style={{ width: isOpen ? "100%" : "0" }}>
      {menuItems.map((menuItem, index) => (
        <MenuItem key={index} item={menuItem} />
      ))}
    </div>
  );
};

export default Sidebar;
